import axios from 'axios';
import { HINTS_URL } from '../config/api';
import { getValidToken, authHeader } from './getValidToken';

export async function verifyEmail(email) {
  return axios.get(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/verifyemail?email=${encodeURIComponent(email)}`, authHeader(await getValidToken()));
}

export async function updateEmail(retrieveToken) {
  return axios.put(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/updateemail/${retrieveToken}`, {}, authHeader(await getValidToken()));
}



// WEBPACK FOOTER //
// ./src/services/email.js